import { getApiB2bEmissionTypesByCountryCode } from '/api/sdk.gen';
import type { GetApiB2bEmissionTypesByCountryCodeResponse } from '/api';
import type { EmissionTypesData, RefrigerantTypeOption } from '/business/shared/state/reducers/emissionTypes';
import type { Dispatch } from '/business/shared/state/actions/types';

const groupKeyMap: Record<string, keyof EmissionTypesData> = {
  commuter_factors: 'commuterFactors',
  commuterFactors: 'commuterFactors',
  deicing: 'deicing',
  fuel: 'fuel',
  refrigerants: 'refrigerants',
  waste: 'waste',
};

const mapEmissionTypes = (emissionTypesData: GetApiB2bEmissionTypesByCountryCodeResponse | undefined) => {
  const emissionTypes: EmissionTypesData = {};
  Object.entries(emissionTypesData || {}).forEach(([rawKey, entries]) => {
    const groupKey = groupKeyMap[rawKey];
    if (!groupKey) {
      return;
    }
    const mappedEntries: RefrigerantTypeOption[] = entries.map((entry) => ({
      displayName: entry.display_name,
      group: entry.group,
      name: entry.name,
      units: entry.units,
    }));
    emissionTypes[groupKey] = mappedEntries;
  });
  return emissionTypes;
};

export const getEmissionTypes =
  (countryCode = 'gb') =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: 'GET_EMISSION_TYPES_STARTED', timestamp: Date.now() });
      await new Promise((resolve) => setTimeout(resolve, 500));
      const { data: emissionTypesData } = await getApiB2bEmissionTypesByCountryCode({
        path: { countryCode: countryCode || 'gb' },
      });
      const emissionTypes = mapEmissionTypes(emissionTypesData);
      await dispatch({ type: 'GET_EMISSION_TYPES_FULFILLED', emissionTypes });
      return emissionTypes;
    } catch (error) {
      dispatch({ type: 'GET_EMISSION_TYPES_REJECTED', error });
      throw error;
    }
  };

export default {
  getEmissionTypes,
};
